import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  title: {
    id: 'studio.5zgvJw',
    defaultMessage: 'Add new members',
  },
  email: {
    id: 'studio.sy+pv5',
    defaultMessage: 'Email',
  },
  help: {
    id: 'studio.+xR2VI',
    defaultMessage:
      'Tabular data can be copied into the input field to add multiple people at once',
  },
  optional: {
    id: 'studio.InWqys',
    defaultMessage: 'Optional',
  },
  cancel: {
    id: 'studio.47FYwb',
    defaultMessage: 'Cancel',
  },
  submit: {
    id: 'studio.OCiHj6',
    defaultMessage: 'Add members',
  },
  error: {
    id: 'studio.+WXioK',
    defaultMessage: 'There was a problem inviting these new members.',
  },
});
